import * as React from 'react';

import Logo from '../matchhaus-logo.svg';
import { isNil } from '../utils/isNil';
import { useThemeColor } from '../hooks/useThemeColor';

interface Props {
  footer?: React.ReactNode;
}

export const LoginLayout: React.FC<Props> = ({ children, footer }) => {
  useThemeColor('#F9F9FB');

  return (
    <div className="min-h-full bg-grey-50 flex flex-col relative">
      <main className="flex-auto flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm z-10">
          <img src={Logo} className="mx-auto mb-10 w-52" />
          {children}
        </div>
      </main>
      {!isNil(footer) ? (
        <footer className="relative z-10 flex-none text-sm text-center py-4 px-4 sm:px-6 lg:px-8">
          {footer}
        </footer>
      ) : null}

      <div className="absolute left-20 -bottom-6 w-16 h-96 bg-amber-200 transform rotate-45  rounded-full mix-blend-multiply filter blur-xl opacity-30"></div>
      <div className="absolute left-16 bottom-40  w-16 h-96 bg-primary-300 transform rotate-45 rounded-full mix-blend-multiply filter blur-xl opacity-30"></div>
    </div>
  );
};
